import * as React from 'react';
import { Button, FormFeedback, FormGroup, Input, Label } from 'reactstrap';

import CloseBtnSvg from '../Svg/closeBtn';

import './Logo.scss';

class Logo extends React.Component<Logo.IProps, Logo.IState> {
  componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
  }

  renderLogo = () => {
    if (!this.props.logo) {
      return <p className="m-auto align-self-center">{this.props.defaultMessage}</p>;
    }

    return (
      <div className="w-100 position-relative">
        <Button className="position-absolute close-button p-0 m-0" onClick={this.props.onDelete}>
          <CloseBtnSvg className="m-0" />
        </Button>
        <img alt={this.props.logo.name} className="mw-100 mh-100 w-auto h-auto m-auto" src={URL.createObjectURL(this.props.logo)} />
      </div>
    );
  };

  render() {
    return (
      <FormGroup className="position-absolute file-upload-container">
        <div className="position-relative">
          <Label className="text-nowrap file-upload-label" for="logo">
            {this.props.labelMessage}
          </Label>
          <Input
            type="file"
            name="logo"
            id="logo"
            accept="image/*"
            onChange={this.props.onChange}
            className={`eon-input-text file-upload pl-0 c-pointer ${this.props.invalidFileType ? 'is-field-error' : ''}`}
            invalid={this.props.invalidFileType}
          />
          <FormFeedback tooltip>{this.props.errorMessage}</FormFeedback>
          <div className="d-flex bg-white file-upload text-center">{this.renderLogo()}</div>
        </div>
      </FormGroup>
    );
  }
}

export default Logo;
